module.exports = __webpack_public_path__ + "media/upmoodspecs.b59ae142.mp4";